import { render, staticRenderFns } from "./ApproveLeave.vue?vue&type=template&id=bbba4924"
import script from "./ApproveLeave.vue?vue&type=script&lang=js"
export * from "./ApproveLeave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports